var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12.5C5.72 12.5 5.5 12.28 5.5 12V6C5.5 5.72 5.72 5.5 6 5.5C6.28 5.5 6.5 5.72 6.5 6V12C6.5 12.28 6.28 12.5 6 12.5Z",
    fill: "#E51058"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5C9.72 12.5 9.5 12.28 9.5 12V6C9.5 5.72 9.72 5.5 10 5.5C10.28 5.5 10.5 5.72 10.5 6V12C10.5 12.28 10.28 12.5 10 12.5Z",
    fill: "#E51058"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 3H5V1.5C5 0.67 5.67 0 6.5 0H9.5C10.33 0 11 0.67 11 1.5V3ZM6 2H10V1.5C10 1.22 9.78 1 9.5 1H6.5C6.22 1 6 1.22 6 1.5V2Z",
    fill: "#E51058"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 16H4.5C3.4 16 2.5 15.1 2.5 14V3C2.5 2.72 2.72 2.5 3 2.5C3.28 2.5 3.5 2.72 3.5 3V14C3.5 14.55 3.95 15 4.5 15H11.5C12.05 15 12.5 14.55 12.5 14V3C12.5 2.72 12.72 2.5 13 2.5C13.28 2.5 13.5 2.72 13.5 3V14C13.5 15.1 12.6 16 11.5 16Z",
    fill: "#E51058"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 3H1.5C1.22 3 1 2.78 1 2.5C1 2.22 1.22 2 1.5 2H14.5C14.78 2 15 2.22 15 2.5C15 2.78 14.78 3 14.5 3Z",
    fill: "#E51058"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.89f9c9a14201bbb0b0e4cb3b406831dd.svg";
export { ForwardRef as ReactComponent };